import {css} from 'styled-components';

import {BackgroundColor, colorVar, getOnColor} from '../Theme/colors';
import {Elevation} from '../Theme/tints';

/**
 * WCAG relative luminance of a `#rrggbb` hex color (0 = black, 1 = white).
 */
export const relativeLuminance = (hex: string): number => {
  const toLinear = (channel: number) => {
    const c = channel / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };
  const r = toLinear(parseInt(hex.slice(1, 3), 16));
  const g = toLinear(parseInt(hex.slice(3, 5), 16));
  const b = toLinear(parseInt(hex.slice(5, 7), 16));
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

export const getColorStyle = (color: BackgroundColor, swap = false) => {
  const counterpartColor =
    color === 'inverseSurface' ? 'inverseOnSurface' : getOnColor(color);
  const background = colorVar(swap ? counterpartColor : color);
  const onColor = colorVar(swap ? color : counterpartColor);
  return {color: onColor, background};
};

type OptionalArgs = [swap?: boolean] | [elevation?: Elevation, swap?: boolean];

export const getColorCss = (color: BackgroundColor, ...args: OptionalArgs) => {
  const [elevation, swap] =
    args.length === 2 || typeof args[0] === 'number'
      ? args
      : [undefined, args[0]];
  const {color: onColor, background} = getColorStyle(color, swap);
  return css`
    color: ${onColor};
    background-color: ${elevation
      ? css`color-mix(in srgb, currentColor calc(var(--theme-elevation-${elevation}-tint) * 100%), ${background})`
      : background};
  `;
};
